import { render, staticRenderFns } from "./secondBack.vue?vue&type=template&id=0c7a76a0&scoped=true&"
import script from "./secondBack.vue?vue&type=script&lang=js&"
export * from "./secondBack.vue?vue&type=script&lang=js&"
import style0 from "./secondBack.vue?vue&type=style&index=0&id=0c7a76a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a76a0",
  null
  
)

export default component.exports